import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useThemeMode } from 'src/assets/theme/ThemeContext';
import { useAppDispatch, useAppSelector } from 'src/redux';
import { resetAppliedJobList } from 'src/redux/slices/candidateLayout';

const AppMessageHandler = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { user } = useAppSelector((state) => state.auth);
  const { setMode } = useThemeMode();
  const { pathname } = useLocation();
  useEffect(() => {
    const onMessage = (e: MessageEvent) => {
      const message = JSON.parse(e.data ?? '{}');
      if (
        message?.type === 'NAVIGATE' &&
        message?.metadata?.path &&
        message.metadata.path !== pathname
      ) {
        navigate(message.metadata.path, { replace: false });
      } else if (message?.type === 'RESET_APPLIED_JOB_LIST') {
        dispatch(resetAppliedJobList());
      } else if (message?.type === 'SET_APPEARANCE') {
        setMode(message?.metadata?.mode);
      }
    };

    window.addEventListener('message', onMessage); // for ios WebView
    (document as any).addEventListener('message', onMessage); // for android WebView
    return () => {
      window.removeEventListener('message', onMessage);
      (document as any).removeEventListener('message', onMessage);
    };
  }, [pathname, dispatch]);

  useEffect(() => {
    if ((window as any)?.ReactNativeWebView && Object.keys(user).length) {
      (window as any).ReactNativeWebView.postMessage(
        JSON.stringify({
          type: 'SET_USER',
          metadata: user,
        }),
      );
    }
  }, [user]);

  return <></>;
};

export default AppMessageHandler;
